export enum PaymentType {
  EURO_ACCOUNT,
  PAYPAL,
  CREDIT_CARD,
  PAYSAFE,
}
